import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "MyTrumpf/Partial Templates/Message Modal",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const MessageModal = (data) => html` <div style="height: 600px">
    <ux-modal
        close-button-text="Schließen"
        close-on-esc-key="false"
        close-on-backdrop-click="true"
        sticky-position="center"
        name="message-modal-${data.modalName}"
    >
        <ux-modal-content>
            <div class="ux-u-d-flex ux-u-flex-ai-center ux-u-flex-dir-column">
                <span class="${data.colorClass}"
                    ><ux-icon
                        name="${data.iconName}"
                        weight="${data.iconWeight}"
                        size-s="${data.iconSizeS}"
                        size-m="${data.iconSizeM}"
                    ></ux-icon
                ></span>
                <h2
                    class="ux-text-headline ux-text-headline--big ux-u-text-align--center ux-u-mb-zero ${data.colorClass}"
                >
                    ${data.headline}
                </h2>
                ${data.text
                    ? html`<p
                          class="ux-text-normal ux-u-text-align--center ux-u-mb-zero"
                      >
                          ${data.text}
                      </p>`
                    : ""}
                <ux-button
                    class="ux-u-mt-fluid-xxs"
                    data-trigger-modal="close,message-modal-${data.modalName}"
                    >Schliessen</ux-button
                >
            </div>
        </ux-modal-content>
    </ux-modal>
    <button
        class="ux-button"
        data-trigger-modal="open,message-modal-${data.modalName}"
    >
        Open Modal
    </button>
</div>`;

export const Info = MessageModal.bind({});
Info.args = {
    modalName: "info",
    iconName: "circle-info",
    iconWeight: "light",
    iconSizeS: "50",
    iconSizeM: "80",
    colorClass: "ux-color-info",
    headline: "Stay in the loop. Important information inside.",
};

export const Success = MessageModal.bind({});
Success.args = {
    modalName: "success",
    iconName: "checkmark",
    iconWeight: "light",
    iconSizeS: "50",
    iconSizeM: "80",
    colorClass: "ux-color-success",
    headline: "Mission accomplished. Your request has been processed.",
};

export const Warning = MessageModal.bind({});
Warning.args = {
    modalName: "warning",
    iconName: "triangle-warning",
    iconWeight: "light",
    iconSizeS: "50",
    iconSizeM: "80",
    colorClass: "ux-color-warning",
    headline: "Something went wrong, please try again later.",
};

export const Error = MessageModal.bind({});
Error.args = {
    modalName: "error",
    iconName: "cross",
    iconWeight: "light",
    iconSizeS: "40",
    iconSizeM: "70",
    colorClass: "ux-color-error",
    headline: "Unable to complete your request. Please check again later.",
};

export const AdditionalText = MessageModal.bind({});
AdditionalText.args = {
    modalName: "additional-text",
    iconName: "circle-info",
    iconWeight: "light",
    iconSizeS: "50",
    iconSizeM: "80",
    colorClass: "ux-color-info",
    headline: "Stay in the loop. Important information inside.",
    text:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt.",
};
